import React, { Fragment, useEffect, useState } from 'react'
import { Button, Message, RadioTile, RadioTileGroup} from 'rsuite'
import { Col, Form, Row } from 'react-bootstrap'
import UserDetailsPanel from './user-details-panel';
import { useNavigate } from 'react-router-dom';
import { red } from '@mui/material/colors';

export default function SuccessForm({handleChange,userDetails}) {

    const onSubmitAction = () => {
        handleChange('stepCount',3);
    }

    const navigation = useNavigate();

    const goBackLogin = () => {
        navigation("/");
    }

    const [username, setUsername] = useState("");

    useEffect(() => {
      const email =userDetails?.email;
      const extractedUsername = email.split("@")[0];
      setUsername(extractedUsername);
    }, []);

  return (
   <Fragment>
       <Row style={{ display: "flex",flexDirection: 'column',alignItems: 'center',justifyContent: 'center' }}> 
                    
                    <Row className='col-sm-12'>
                        <Col sm={6}>
                            <UserDetailsPanel userDetails={userDetails}/>
                            </Col>
                            <Col sm={6}>
                               
                               <Message type="success" centered showIcon header="Your account has been successfully created!">
                                    <p> Sign In to enjoy the services at USJNet Sphere. 
                                    </p>
                                    <p style={{paddingBottom:'20px',marginTop:'20px'}}>
                                       <b>Your USJNet ID is:  <span style={{ color: 'red',fontSize:'20px' }}>{username}</span></b>
                                    </p>
                                    <p>
                                        <Button onClick={goBackLogin} style={{ width: '180px', backgroundColor: '#990000', color: 'white' }} type="button">Sign In</Button>
                                    </p>
                                </Message>
                                  
                            </Col>
                        </Row>
                    </Row>
    </Fragment>
  )
}
